<script>
import BackgroundHalfCircle from '@/components/BackgroundHalfCircle'
import DialogUtils from '@/utils/dialogUtils'

export default
{
    name: 'settings-view',

    render () 
    {
        const user = this.$store.state.user

        return (
            <div id='settings-view'>
                <BackgroundHalfCircle settings-mobile={{ height: '35vh' }} settings-tablet={{ height: '20vh'}} settings-desktop={{ height: '10vh' }} />

                <div id='view-content'>
                    <span id='settings-title' on-click={this.hiddenNavigationClicked}>
                        <inline-svg v-show={this.$route.path != '/settings'} id='back-icon' src={require('@/assets/img/back-thick.svg')} on-click={() => this.$router.back()} />
                        {this.title}
                    </span>
                    
                    <div id='settings-card-outsite'>
                        <div id='settings-card' class={`${user.isLogged ? 'user-is-logged' : ''} ${this.$route.path == '/settings' ? 'index' : ''}`}>
                            <router-view ref='router' />
                        </div>
                    </div>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            hiddenNavigationClickedCount: 0
        }
    },

    computed:
    {
        title ()
        {
            return this.$route.meta.viewTitle || 'Paramètres'
        }
    },

    mounted ()
    {
    },

    methods:
    {
        async hiddenNavigationClicked ()
        {
            this.hiddenNavigationClickedCount += 1
            if (this.hiddenNavigationClickedCount > 10)
            {
                this.$router.push(await DialogUtils.promptAsync())
            }
        }
    },

    components:
    {
        BackgroundHalfCircle
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#settings-view
{
    margin-top: 6vh;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);

    .OnDesktop({ margin-bottom: 4vw; });

    #view-content
    {
        display: flex;
        flex-direction: column;

        #settings-title
        {
            color: white;
            font-family: Nunito;
            font-weight: bold;
            font-size: 7vw;
            margin-left: 5vw;

            .OnTablet({
                font-size: 5vw;
            });

            .OnDesktop({
                font-size: 2vw;
                border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
            });
        }

        #back-icon
        {
            height: 20px;
            fill: white;
            margin-right: 15px;
            cursor: pointer;

            .OnLarge({ height: 28px; });
        }

        #settings-card-outsite
        {
            .OnDesktop({
                border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
            });

            #settings-card
            {
                background-color: var(--theme-content-background-color);
                margin: auto;
                border-radius: 14px;
                margin-top: 30px;
                display: flex;
                flex-flow: column;
                padding: 0px 20px;
                width: 84vw;
                box-shadow: var(--theme-box-shadow-sharp);

                .OnDesktop({
                    width: 45vw;
                    padding: 0 2vw;
                });

                .OnLarge({ width: 40vw; });

                &.user-is-logged.index
                {
                    margin-top: 100px;
                }

                .settings-menu-item
                {
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Settings.vue